var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonNavbar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8465 12.4787C13.8465 15.8716 16.6075 18.6326 20.0003 18.6326C23.3931 18.6326 26.1542 15.8716 26.1542 12.4787C26.1542 9.08592 23.3931 6.32489 20.0003 6.32489C16.6075 6.32489 13.8465 9.08592 13.8465 12.4787ZM30.9405 32.3078H32.308V30.9403C32.308 25.663 28.0126 21.3676 22.7354 21.3676H17.2653C11.9866 21.3676 7.69263 25.663 7.69263 30.9403V32.3078H30.9405Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonNavbar);
export default __webpack_public_path__ + "static/media/PersonNavbar.3369d34ac5ce65cb91cbbbfaf50b0620.svg";
export { ForwardRef as ReactComponent };